var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c(_vm.layout,{tag:"component"},[_c('h1',[_vm._v("This is the Author's page")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }